// extracted by mini-css-extract-plugin
export default {"form":"form_form__mhv3I","btn":"form_btn__80TOH"};